import { Observer } from 'mobx-react';
import * as React from 'react';

import { FormModal } from '../components/FormModal';

import { changeDistanceModalStore, openChangeDistanceModalStore } from '../stores';

export const Base = () => {
  return <Observer>{() => (openChangeDistanceModalStore.value && changeDistanceModalStore.value ? <FormModal /> : null)}</Observer>;
};
